module.exports = __webpack_public_path__ + "static/media/current_loc_btn.09c26e80.png";